/* MoviePalette search RESULTS page — the rest of the Sparq replacement.
 *
 * Renders the full experience Sparq provided on /search: results grid, tag filters,
 * collection filters, star-rating filter, sort, and a result count. All of it runs
 * against the in-memory index, so filtering and sorting are instant and cost no
 * network requests at all.
 *
 * Depends on mp-search.js for the index + fuzzy matcher (window.MPSearch).
 */
(function () {
  'use strict';

  var MONEY = window.MP_SEARCH_CURRENCY || '$';
  var PAGE = 24;

  var root, data, state = { q: '', tags: [], colls: [], rating: 0, sort: 'relevance', shown: PAGE };
  var matched = [];   // rows matching the query, before facet filters

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Two gotchas, both found by measurement:
     1. Use ?width=, not the _500x filename suffix — the suffix 404s on most images.
     2. The Admin API's featuredImage.url reports the wrong folder for some products
        (it says files/ where the CDN actually serves products/), so the folder in the
        index cannot be trusted. onImgError swaps to the other folder once. */
  function img(r, w) {
    if (!r[3]) return '';
    return data.base + (data.dirs[r[6]] || data.dirs[0]) + r[3] + '?width=' + w;
  }

  function altImg(r, w) {
    return data.base + (data.dirs[r[6] ? 0 : 1]) + r[3] + '?width=' + w;
  }

  window.mpspImgError = function (el) {
    if (el.dataset.retried) { el.style.visibility = 'hidden'; return; }
    el.dataset.retried = '1';
    el.src = el.dataset.alt;
  };

  /* ---------- filtering ---------- */

  function passes(r) {
    var i;
    for (i = 0; i < state.tags.length; i++) if (r[7].indexOf(state.tags[i]) < 0) return false;
    for (i = 0; i < state.colls.length; i++) if (r[8].indexOf(state.colls[i]) < 0) return false;
    if (state.rating === -1) { if (r[10] > 0) return false; }        // "no reviews"
    else if (state.rating > 0 && r[9] < state.rating) return false;
    return true;
  }

  function filtered() { return matched.filter(passes); }

  function sorted(list) {
    var l = list.slice();
    if (state.sort === 'price-asc') l.sort(function (a, b) { return a[4] - b[4]; });
    else if (state.sort === 'price-desc') l.sort(function (a, b) { return b[4] - a[4]; });
    else if (state.sort === 'rating') l.sort(function (a, b) { return b[9] - a[9] || b[10] - a[10]; });
    else if (state.sort === 'newest') l.sort(function (a, b) { return b[1] - a[1]; });
    else if (state.sort === 'title') l.sort(function (a, b) { return a[0].localeCompare(b[0]); });
    return l;                                          // 'relevance' keeps match order
  }

  /* counts for each facet, computed against the OTHER active facets so the numbers
     tell you what you'd actually get — the same behaviour Sparq's sidebar has */
  function counts(kind) {
    var save = state[kind], out = {};
    state[kind] = [];
    var pool = matched.filter(passes);
    state[kind] = save;
    var f = kind === 'tags' ? 7 : 8;
    for (var i = 0; i < pool.length; i++) {
      var ids = pool[i][f];
      for (var j = 0; j < ids.length; j++) out[ids[j]] = (out[ids[j]] || 0) + 1;
    }
    return out;
  }

  function ratingCounts() {
    var save = state.rating; state.rating = 0;
    var pool = matched.filter(passes); state.rating = save;
    var o = { 4: 0, 3: 0, 2: 0, 1: 0, none: 0 };
    for (var i = 0; i < pool.length; i++) {
      var r = pool[i];
      if (r[10] === 0) { o.none++; continue; }
      for (var s = 4; s >= 1; s--) if (r[9] >= s) o[s]++;
    }
    return o;
  }

  /* ---------- rendering ---------- */

  function stars(n) {
    var h = '';
    for (var i = 1; i <= 5; i++) h += '<span class="mpsp-star' + (i <= n ? ' on' : '') + '">&#9733;</span>';
    return h;
  }

  function facet(title, kind, list, active, cnt) {
    var h = '<div class="mpsp-facet"><h3>' + title + '</h3><ul>';
    var any = false;
    for (var i = 0; i < list.length; i++) {
      var label = kind === 'colls' ? list[i][1] : list[i];
      var n = cnt[i] || 0;
      var on = active.indexOf(i) > -1;
      if (!n && !on) continue;
      any = true;
      h += '<li><label><input type="checkbox" data-kind="' + kind + '" value="' + i + '"' +
        (on ? ' checked' : '') + '><span>' + esc(label) + '</span><em>[' + n + ']</em></label></li>';
    }
    return any ? h + '</ul></div>' : '';
  }

  function buildSide() {
    var rc = ratingCounts();
    var n = state.tags.length + state.colls.length + (state.rating ? 1 : 0);
    var open = document.querySelector('.mpsp-side.open') ? ' open' : '';
    var side = '<aside class="mpsp-side' + open + '">' +
      '<button class="mpsp-toggle" type="button">Filter' +
      (n ? ' (' + n + ')' : ' by') + '</button>' +
      '<div class="mpsp-side-head"><h2>Filter by</h2>' +
      ((state.tags.length || state.colls.length || state.rating) ?
        '<button class="mpsp-clear" type="button">Clear</button>' : '') + '</div>' +
      facet('Tags', 'tags', data.tags, state.tags, counts('tags')) +
      facet('Collections', 'colls', data.colls, state.colls, counts('colls')) +
      '<div class="mpsp-facet"><h3>Rating</h3><ul>';
    for (var s = 4; s >= 1; s--) {
      side += '<li><label><input type="radio" name="mpsp-rating" data-kind="rating" value="' + s + '"' +
        (state.rating === s ? ' checked' : '') + '><span>' + stars(s) + ' &amp; Up</span><em>[' + rc[s] + ']</em></label></li>';
    }
    side += '<li><label><input type="radio" name="mpsp-rating" data-kind="rating" value="-1"' +
      (state.rating === -1 ? ' checked' : '') + '><span>No Reviews</span><em>[' + rc.none + ']</em></label></li>';
    side += '</ul></div></aside>';
    return side;
  }

  function render() {
    if (!root) return;
    var t0 = performance.now();
    var list = sorted(filtered());
    var ms = (performance.now() - t0).toFixed(0);
    var page = list.slice(0, state.shown);
    var side = buildSide();

    // No timing figure. "in 0 ms" is a boast about the software, not information a
    // shopper can use — and ours is always 0, which reads as broken rather than fast.
    var head = '<div class="mpsp-head"><p class="mpsp-count"><strong>' + list.length +
      '</strong> result' + (list.length === 1 ? '' : 's') + '</p>' +
      '<label class="mpsp-sort"><span class="visually-hidden">Sort by</span><select>' +
      [['relevance', 'Relevance'], ['rating', 'Best Rated'], ['price-asc', 'Price: Low to High'],
       ['price-desc', 'Price: High to Low'], ['newest', 'Newest Film'], ['title', 'A–Z']]
        .map(function (o) {
          return '<option value="' + o[0] + '"' + (state.sort === o[0] ? ' selected' : '') + '>' + o[1] + '</option>';
        }).join('') + '</select></label></div>';

    var grid = '';
    if (!list.length) {
      grid = '<div class="mpsp-none"><p>No films match those filters.</p>' +
        '<p class="mpsp-none-sub">Try removing a filter, or search the title on its own.</p></div>';
    } else {
      grid = '<ul class="mpsp-grid">';
      for (var i = 0; i < page.length; i++) {
        var r = page[i];
        grid += '<li class="mpsp-card"><a href="/products/' + esc(r[2]) + '">' +
          '<span class="mpsp-img">' + (r[3] ? '<img src="' + esc(img(r, 500)) +
            '" data-alt="' + esc(altImg(r, 500)) + '" onerror="mpspImgError(this)" alt="' +
            esc(r[0]) + ' color palette canvas print" width="500" height="500">' : '') + '</span>' +
          // film name + year only. The "Color Palette Canvas Art" suffix is on every
          // product, so in a grid of results it is pure noise — it pushes titles onto
          // three lines and tells a shopper nothing that distinguishes one from another.
          '<span class="mpsp-title">' + esc(r[0]) + (r[1] ? ' (' + r[1] + ')' : '') + '</span>' +
          (r[10] ? '<span class="mpsp-rate">' + r[9].toFixed(1) + ' ' +
            stars(Math.round(r[9])) + '<em>' + r[10] + ' ratings</em></span>' : '') +
          '<span class="mpsp-price">' + MONEY + r[4] +
          (r[5] > r[4] ? ' <s>' + MONEY + r[5] + '</s>' : '') + '</span></a></li>';
      }
      grid += '</ul>';
      if (list.length > state.shown) {
        grid += '<button class="mpsp-more" type="button">Load more (' +
          (list.length - state.shown) + ' remaining)</button>';
      }
    }

    root.innerHTML = side + '<div class="mpsp-main">' + head + grid + '</div>';
  }

  /* ---------- events / state ---------- */

  function syncUrl() {
    var p = new URLSearchParams();
    if (state.q) p.set('q', state.q);
    if (state.tags.length) p.set('tags', state.tags.join(','));
    if (state.colls.length) p.set('colls', state.colls.join(','));
    if (state.rating) p.set('rating', state.rating);
    if (state.sort !== 'relevance') p.set('sort', state.sort);
    history.replaceState(null, '', location.pathname + '?' + p.toString());
  }

  function readUrl() {
    var p = new URLSearchParams(location.search);
    state.q = p.get('q') || '';
    state.tags = (p.get('tags') || '').split(',').filter(function (x) { return x !== ''; }).map(Number);
    state.colls = (p.get('colls') || '').split(',').filter(function (x) { return x !== ''; }).map(Number);
    state.rating = parseInt(p.get('rating') || '0', 10) || 0;
    state.sort = p.get('sort') || 'relevance';
  }

  function bind() {
    root.addEventListener('change', function (e) {
      var el = e.target, kind = el.dataset.kind;
      if (kind === 'tags' || kind === 'colls') {
        var v = Number(el.value), arr = state[kind], i = arr.indexOf(v);
        if (el.checked && i < 0) arr.push(v); else if (!el.checked && i > -1) arr.splice(i, 1);
      } else if (kind === 'rating') {
        state.rating = Number(el.value);
      } else if (el.tagName === 'SELECT') {
        state.sort = el.value;
      } else return;
      state.shown = PAGE;
      takenOver = true;          // client grid replaces the server-rendered one
      syncUrl(); render();
    });
    root.addEventListener('click', function (e) {
      if (e.target.classList.contains('mpsp-toggle')) {
        e.target.closest('.mpsp-side').classList.toggle('open');
        return;
      }
      if (e.target.classList.contains('mpsp-more')) { state.shown += PAGE; render(); }
      if (e.target.classList.contains('mpsp-clear')) {
        state.tags = []; state.colls = []; state.rating = 0; state.shown = PAGE;
        syncUrl(); render();
      }
    });
  }

  /* Collection pages arrive with a server-rendered grid already in the HTML, because
     they get indexed and Google must see real products. So on a collection we render
     ONLY the filter sidebar on load and leave the server's grid alone; the client grid
     takes over the moment a filter or sort is actually touched. Search pages have no
     server grid, so they render immediately. */
  var collectionMode = false, takenOver = false;

  function renderSidebarOnly() {
    var side = root.querySelector('.mpsp-side');
    if (!side) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = buildSide();
    side.replaceWith(tmp.firstChild);
  }

  function start() {
    root = document.getElementById('mp-search-results');
    if (!root || !window.MPSearch) return;
    readUrl();
    var coll = root.dataset.collection;
    collectionMode = !!coll;
    if (!collectionMode) root.innerHTML = '<div class="mpsp-loading">Searching…</div>';

    window.MPSearch.load().then(function () {
      data = window.MPSearch.data();
      if (collectionMode) {
        var ci = -1;
        for (var i = 0; i < data.colls.length; i++) if (data.colls[i][0] === coll) ci = i;
        matched = ci < 0 ? data.rows.slice()
                         : data.rows.filter(function (r) { return r[8].indexOf(ci) > -1; });
        bind();
        // if the URL already carries filters, take over straight away
        if (state.tags.length || state.colls.length || state.rating || state.sort !== 'relevance') {
          takenOver = true; render();
        } else {
          renderSidebarOnly();
        }
      } else {
        matched = state.q ? window.MPSearch.search(state.q, 5000) : data.rows.slice();
        bind(); render();
      }
    }).catch(function () {
      if (!collectionMode) {
        root.innerHTML = '<div class="mpsp-none"><p>Search is unavailable right now.</p></div>';
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
